(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bh-gewaehrleistung-label"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bh-legal-guarantee-open]');

    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (dialog && typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
      return;
    }

    if (
      event.target instanceof HTMLDialogElement &&
      event.target.classList.contains('bh-legal-guarantee-dialog')
    ) {
      event.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
